module.exports = ({ scope = document } = {}) => {
  const allComponents = scope.querySelectorAll('.hse-step-by-step')

  if (!allComponents.length) {
    return
  }

  const updateStepState = (toggle, panel, isOpen) => {
    const label = toggle.querySelector('.hse-step-by-step__step-toggle-label')
    const showLabel = toggle.getAttribute('data-show-label') || 'Show'
    const hideLabel = toggle.getAttribute('data-hide-label') || 'Hide'

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    label.textContent = isOpen ? hideLabel : showLabel

    if (isOpen) {
      panel.removeAttribute('hidden')
    } else {
      panel.setAttribute('hidden', 'hidden')
    }
  }

  const updateGlobalState = (container) => {
    const globalToggle = container.querySelector(
      '.hse-step-by-step__toggle-all'
    )
    const globalLabel = container.querySelector(
      '.hse-step-by-step__toggle-all-label'
    )
    const stepToggles = container.querySelectorAll(
      '.hse-step-by-step__step-toggle'
    )

    const allOpen = Array.from(stepToggles).every(
      (toggle) => toggle.getAttribute('aria-expanded') === 'true'
    )

    const showAllLabel =
      globalToggle.getAttribute('data-show-all-label') || 'Show all steps'
    const closeAllLabel =
      globalToggle.getAttribute('data-close-all-label') || 'Close all steps'

    globalToggle.setAttribute('aria-expanded', allOpen ? 'true' : 'false')
    globalLabel.textContent = allOpen ? closeAllLabel : showAllLabel
  }

  const toggleAllSteps = (container, shouldOpen) => {
    container
      .querySelectorAll('.hse-step-by-step__step-toggle')
      .forEach((toggle) => {
        const panel = container.querySelector(
          `#${toggle.getAttribute('aria-controls')}`
        )
        updateStepState(toggle, panel, shouldOpen)
      })
    updateGlobalState(container)
  }

  allComponents.forEach((container) => {
    const globalToggle = container.querySelector(
      '.hse-step-by-step__toggle-all'
    )
    const stepToggles = container.querySelectorAll(
      '.hse-step-by-step__step-toggle'
    )

    stepToggles.forEach((toggle) => {
      const panelId = toggle.getAttribute('aria-controls')
      const panel = container.querySelector(`#${panelId}`)
      const header = toggle.closest('.hse-step-by-step__step-header')

      toggle.addEventListener('click', () => {
        const isOpen = toggle.getAttribute('aria-expanded') !== 'true'
        updateStepState(toggle, panel, isOpen)
        updateGlobalState(container)
      })

      toggle.addEventListener('focus', () => {
        const stepEl = toggle.closest('.hse-step-by-step__step')
        if (stepEl) stepEl.classList.add('hse-step-by-step__step--focused')
      })

      toggle.addEventListener('blur', () => {
        const stepEl = toggle.closest('.hse-step-by-step__step')
        if (stepEl) stepEl.classList.remove('hse-step-by-step__step--focused')
      })

      if (header) {
        header.addEventListener('click', (e) => {
          if (!toggle.contains(e.target) && e.target !== toggle) {
            toggle.click()
            toggle.focus()
          }
        })
      }

      const stepEl = toggle.closest('.hse-step-by-step__step')
      const marker = stepEl
        ? stepEl.querySelector('.hse-step-by-step__step-marker')
        : null
      if (marker) {
        marker.addEventListener('click', () => {
          toggle.click()
          toggle.focus()
        })
      }
    })

    globalToggle.addEventListener('click', () => {
      const shouldOpen = globalToggle.getAttribute('aria-expanded') !== 'true'
      toggleAllSteps(container, shouldOpen)
    })

    updateGlobalState(container)
  })
}
